export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'POLYGONS_SET':
      return payload
    case 'POLYGON_CREATE':
      return [payload, ...state]
    case 'POLYGON_UPDATE':
      return state.map(item => {
        if (item.id != payload.id) return item
        const updated = Object.assign({}, item, payload)
        delete updated.mapObj
        return updated
      })
    case 'POLYGON_DELETE':
      return state.filter(item => item.id != payload)
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
